module.exports = __webpack_public_path__ + "static/media/Spotenu.20b2b71b.png";